import React, { useRef } from 'react';
import './Index.css';
import {
    Card,
    Container,
    Row,
    Col,
    Button,
} from "reactstrap";

import FSKLogo from "assets/img/brand/FSK.svg";
import elcarIpad from "../../../../assets/img/mockups/elcar-ipad.png";

const Hotpage = () => {
    const formRef = useRef(null);

    const scrollToForm = () => {
        setTimeout(() => {
            formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    };


    return (
        <div className="hotpage-wrapper">
            <Container fluid className="p-0">
                <Row className="hotpage-row no-gutters">
                    {/* Coluna da Imagem e Título */}
                    <Col md="6" className="hotpage-content-col bg-white d-flex flex-column justify-content-center p-5">
                        <div className="hotpage-content-overlay"></div>
                        <div className="hotpage-content-wrapper text-center">
                            <div className="hotpage-text-content mb-5">
                                <img
                                    src={FSKLogo}
                                    alt="Logo FSK"
                                    className="fsk-logo mb-5"
                                />
                                <h1 className="hotpage-title display-4 mb-2 font-weight-bold text-white">
                                    The power of our curriculum now in an app
                                </h1>
                                <p className="hotpage-subtitle lead text-white">
                                    Join the waitlist and be among the first to experience the future of our ELCAR!
                                </p>
                                <Button
                                    color="light"
                                    className="hotpage-mobile-button mt-4"
                                    onClick={scrollToForm}
                                >
                                    Get Early Access
                                </Button>
                            </div>
                            <div className="hotpage-mockup-container">
                                <img
                                    src={elcarIpad}
                                    alt="Elcar iPad Mockup"
                                    className="hotpage-mockup img-fluid"
                                />
                                <div className="hotpage-glow"></div>
                            </div>
                        </div>
                    </Col>

                    {/* Coluna do Formulário */}
                    {/* AQUI ESTÁ A MUDANÇA: Envolvemos a Col com um div e colocamos a ref nele */}
                        <Col  md="6" className="bg-white hotpage-form-col d-flex align-items-top justify-content-center p-4">
                            <div ref={formRef} className="hotpage-form-wrapper w-100">
                                    <div className="p-1 p-md-2">
                                        <iframe
                                            src="https://docs.google.com/forms/d/e/1FAIpQLSf_Giu7QwdutEzyWU57ZMGBQSlwh8OYTKQS3dwYIhyfdUglGw/viewform?embedded=true"
                                            width="100%"
                                            height="720"
                  
                                            title="Wait list"
                                            className="hotpage-iframe"
                                        >
                                            Loading…
                                        </iframe>
                                    </div>
                            </div>
                        </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Hotpage;